var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSend01 = function SvgSend01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F76B15",
    fillRule: "evenodd",
    d: "m14.5 4.56-5.749 5.75 1.75 4.499zM7.69 9.249l5.75-5.75-10.25 4zm7.795-8.143c.138-.04.414-.112.71-.013.336.112.6.375.712.71.099.298.027.574-.013.711-.043.15-.113.328-.183.508l-4.963 12.717c-.078.2-.154.394-.228.544-.064.13-.206.404-.501.557-.326.17-.713.17-1.039 0-.295-.154-.437-.429-.5-.558a7 7 0 0 1-.227-.544l-1.958-5.034-5.007-1.947-.026-.01a7 7 0 0 1-.544-.227c-.13-.064-.404-.206-.558-.5a1.13 1.13 0 0 1 0-1.04c.153-.294.428-.437.557-.5.15-.075.343-.15.543-.228l.027-.01 12.691-4.953c.18-.07.358-.14.507-.183",
    clipRule: "evenodd"
  })));
};
export default SvgSend01;